<template>
  <div class="c-modal c-modal--reward-order t-modal is-visible">

    <section class="c-modal__box c-modal--reward-order__box">

      <div v-if="orderErrorMessage !== null && typeof orderErrorMessage === 'object'" class="c-modal--reward-order__box__content">
        <h1 class="c-modal--reward-order__title t-headline">{{ $t('web.catalog_order_error.error_title', {error_code: orderErrorMessage.code }) }}</h1>
        <p class="c-modal--reward-order__error-message u-paragraph u-center-text">
          <span>{{ $t('web.catalog_order_error.error_message', {reason: $t(orderErrorMessage.reason), detail: $t(orderErrorMessage.detail.order)}) }}</span>
        </p>
      </div>
      <div v-else class="c-modal--reward-order__box__content">
        <h1 class="c-modal--reward-order__title t-headline">{{ $t('web.catalog_order_error.error_title_no_code') }}</h1>
        <p class="c-modal--reward-order__error-message u-paragraph u-center-text">
          <span>{{ orderErrorMessage }}</span>
        </p>
      </div>

      <div class="c-modal--reward-order__actions">

        <button
          @click="$emit('close')"
          class="c-button
                 c-modal--reward-order__actions__button
                 c-modal--reward-order__actions__button--full-width
                 t-button-plain"
        >
          {{ $t('web.catalog_order_error.back_button') }}
        </button>

      </div>

    </section>

    <div class="c-modal__overlay"></div>

  </div>

</template>
<script>
import { } from 'vuex'

export default {
  props: ['orderErrorMessage']
}
</script>



// WEBPACK FOOTER //
// OrderError.vue?4b0e566f